"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconEditBoard = function IconEditBoard(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconEditBoard', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    d: "M6.065 1.403c.402 0 .728.314.728.702a.715.715 0 0 1-.728.701H2.182a.715.715 0 0 0-.727.702v9.822c0 .388.325.702.727.702h10.182a.715.715 0 0 0 .727-.702V9.584c0-.388.326-.702.727-.702.402 0 .727.314.727.702v3.746c0 1.163-.976 2.105-2.181 2.105H2.182C.977 15.435 0 14.493 0 13.33V3.508c0-1.162.977-2.105 2.182-2.105zM12.878.205l2.909 2.807a.684.684 0 0 1 0 .992L8.514 11.02a.741.741 0 0 1-.514.206H5.09a.715.715 0 0 1-.726-.702V7.718a.69.69 0 0 1 .213-.496L11.849.205a.746.746 0 0 1 1.029 0zm-.514 1.489L5.818 8.008v1.814h1.88l6.546-6.314-1.88-1.814z"
  }));
};

var _default = IconEditBoard;
exports.default = _default;